export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10209.2167c557.jpg";